import React from 'react';
import {Controller} from "react-hook-form";
import {Checkbox, FormControlLabel, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";


export const ChechBoxMultiQuestion = ({
	                                      question,
	                                      control,
	                                      list,
	                                      disabled = false,
	                                      defaultValue = false,
	                                      sm = 6
                                      }) => {
	return (
        <React.Fragment>
            <Grid container spacing={1}>
				{
					question !== "" &&
					<Grid item xs={12}>
						<Typography variant={"subtitle1"}>
							{question}
						</Typography>
					</Grid>
				}
				{
					list.map((item) => {
						return (
                            <Grid item xs={12} sm={sm} key={item}>
                                <FormControlLabel
									style={{
										alignItems: "flex-start"
									}}
									disabled={disabled}
									control={
										<Controller
											name={item.replace(/[\W_]+/g, "_")}
											control={control}
											defaultValue={defaultValue}
											render={(props) => (
												<Checkbox
													{...props}
													checked={props.value}
													onChange={(e) => {
														props.onChange(e.target.checked)
													}}
												/>
											)}
										/>
									}
									label={item}
								/>
                            </Grid>
                        );
					})
				}
			</Grid>
        </React.Fragment>
    );
};
